// Descarga anticipada de imágenes: las pide al navegador en un momento libre para que ya estén en caché cuando se
// abra la página que las usa. Cada imagen se pide una sola vez.

/** Imágenes ya pedidas en esta visita. @type {Set<string>} */
const pedidas = new Set();

/**
 * Corre la función cuando el navegador está libre (o en cuanto se pueda, si no tiene requestIdleCallback).
 * @param {() => void} tarea
 */
const cuandoHayaTiempo = (tarea) => {
  if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(tarea, { timeout: 1500 });
  else window.setTimeout(tarea, 200);
};

/**
 * Pide de antemano las imágenes que aún no se han pedido.
 * @param {string[]} urls
 */
export function precargarImagenes(urls) {
  const nuevas = urls.filter((u) => !pedidas.has(u));
  if (!nuevas.length) return;
  nuevas.forEach((u) => pedidas.add(u));
  cuandoHayaTiempo(() => nuevas.forEach((u) => {
    const imagen = new Image();
    imagen.decoding = 'async';
    imagen.src = u;
  }));
}
